import { useEffect, useState } from "react";
import Router, { useRouter } from "next/router";
import PropTypes from "prop-types";
import { Spinner } from "@aqar-app/aqar-design-system";
import { useAuthState } from "@/contexts/auth/auth.provider";
import styles from "../containers/auth/auth.module.scss";

const isMapRoute = (pathname) => {
  const regex = new RegExp(`/map/|/daily-map\\w*`);
  return regex.test(pathname);
};

const withAuthentication = (WrappedComponent) => {
  return ({ tokenFromServerCookie, ...props }) => {
    const router = useRouter();
    const token = useAuthState("token") || tokenFromServerCookie;
    const [isLoading, setIsLoading] = useState(!token);

    const isMapPath = isMapRoute(router.asPath);

    useEffect(() => {
      if (!(token || tokenFromServerCookie)) {
        setIsLoading(true);
        Router.push({
          pathname: "/login",
          query: {
            returnTo: router.asPath,
            // TODO: find a way to make this generic and supports other routes
            ...(isMapPath && {
              message: "للوصول إلى البحث على الخريطة تحتاج إلى تسجيل الدخول",
            }),
          },
        }).then(() => setIsLoading(false));
        return;
      }
      setIsLoading(false);
    }, [token]);

    if (isLoading)
      return (
        <div className={styles.spinnerWrapper}>
          <Spinner className={styles.spinner5rem} />
        </div>
      );
    if (token) return <WrappedComponent {...props} />;
  };
};

withAuthentication.propTypes = {
  WrappedComponent: PropTypes.node.isRequired,
};

export default withAuthentication;
